import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Create = () => {

    const {addData} = useEntityCrud('Person/SetPerson');
    const navigate = useNavigate();

    const initialValues = {
        name: '',
        lastName: '',
        nationalCode: '',
        phone: '',
        cellphone: '',
        email: '',
        branchId: '',
        personTypeId: ''
    };
    
    const validationSchema = Yup.object({
        name: Yup.string()
        .required(),
        lastName: Yup.string()
        .required(),
        nationalCode: Yup.string()
        .test('nationalCode','کد ملی وارد شده معتبر نمی باشد',code => {
            if(!code || code.length != 10)
                return false;
            let L = code.length;
            if(L < 8 || parseInt(code,10) == 0) return false;
            code = ('0000' + code).substr(L + 4 - 10);
            if(parseInt(code.substr(3,6),10)==0) return false;
            let c = parseInt(code.substr(9,1),10);
            let s = 0;
            for(let i = 0;i < 9;i++)
                s += parseInt(code.substr(i,1),10) * (10 - i);
            s = s % 11;
            return (s < 2 && c == s) || (s >= 2 && c == (11 - s));
        })
        .required(),
        // phone: Yup.string().matches(/^[0-9\-\(\)]*$/,'شماره تماس وارد شده معتبر نیست').required(),
        cellphone: Yup.string()
        .test('cellphone','شماره همراه وارد شده معتبر نمی باشد',value => {
            return value && /^\d+$/.test(value.toString().replace('-','')) && value.startsWith('09') && value.length == 12;
        }),
        personTypeId: Yup.number()
        .required(),
        branchId: Yup.number()
        .required()
    });
    
    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            name: values.name,
            lastName: values.lastName,
            nationalCode: values.nationalCode,
            phone: values.phone,
            cellphone: values.cellphone.replace('-',''),
            email: values.email,
            branchId: values.branchId,
            roleId: values.roleId,
            personTypeId: values.personTypeId,
            branchTitle: ''
       };
       addData(postedData).then(({data}) => {
            if(data.status){
                toast.success('پرسنل جدید با موفقیت ایجاد شد');
                return navigate('/personnel');
            }
            else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/personnel',{replace: true});
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ایجاد پرسنل جدید</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Create;